import { FormattedMessage } from 'react-intl';

export function ReadyQuoteDetails() {
  return (
    <div className="flex-y py-0 align-items-center justify-content-center quote-details-min-height">
      <i className="icon icon-lg">checklist</i>
      <h4>
        <FormattedMessage id="sidePanel.quoteStatus.readyToPrice" defaultMessage="Ready to price" />
      </h4>
      <p>
        <FormattedMessage
          id="sidePanel.quoteStatus.readyToPrice.description"
          defaultMessage="All set! You are ready to price the quote."
        />
      </p>
    </div>
  );
}
